/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResourceLinkCreateRequestTitle } from './resourceLinkCreateRequestTitle';
import type { ResourceLinkCreateRequestDescription } from './resourceLinkCreateRequestDescription';
import type { ResourceLinkCreateRequestCitation } from './resourceLinkCreateRequestCitation';

/**
 * Request schema for creating a link resource
 */
export interface ResourceLinkCreateRequest {
  url: string;
  title?: ResourceLinkCreateRequestTitle;
  description?: ResourceLinkCreateRequestDescription;
  citation?: ResourceLinkCreateRequestCitation;
  /** If true, attempt to auto-generate title, description and citation from the URL */
  autoGenerateMetadata?: boolean;
}
